import React, { createContext, useCallback, useState } from 'react';
import Snackbar from '../components/common/Snackbar';

export const SnackbarContext = createContext({
  showSnackbar: () => {},
  hideSnackbar: () => {},
});

export const SnackbarProvider = ({ children }) => {
  const [snack, setSnack] = useState({ message: null, type: 'info', duration: 3000 });

  const showSnackbar = useCallback((message, options = {}) => {
    const { type = 'info', duration = 3000 } = options;
    setSnack({ message, type, duration });
  }, []);

  const hideSnackbar = useCallback(() => {
    setSnack({ message: null, type: 'info', duration: 3000 });
  }, []);

  return (
    <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
      {children}
      {snack.message ? (
        <Snackbar
          message={snack.message}
          type={snack.type}
          duration={snack.duration}
          onClose={hideSnackbar}
        />
        ): 
        <></>
      }
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
